import gql from 'graphql-tag';

export const fixTemporallyCheckupReservationForIndividual = gql`
  mutation fixTemporallyCheckupReservationForIndividual($input: FixTreatmentInput!) {
    fixTreatmentCheckupIndividual(input: $input) {
      id
    }
  }
`;
